import { Link } from 'react-router-dom';

import { Dropdown, Col, Row, Avatar, Divider } from 'antd';

import { UserOutlined } from '@ant-design/icons';
import { getUserData, logout } from '../../../api/auth';
import { Setting2 } from 'iconsax-react';

export default function HeaderUser() {
  const userData = getUserData();
  const menu = (
    <div className='hp-user-dropdown hp-border-radius hp-bg-black-0 hp-bg-dark-100 hp-border-color-dark-80 hp-py-24 hp-px-18 hp-mt-16'>
      <span className='hp-d-block h5 hp-font-weight-500 hp-text-color-black-100 hp-text-color-dark-0 hp-mb-16'>
        {userData ? userData.username : ''}
      </span>

      {userData && userData.isAdmin && (
        <>
          <Row>
            <Col span={24}>
              <Link
                to='/backoffice'
                className='hp-d-flex-center hp-p1-body hp-font-weight-500 hp-my-4 hp-py-8 hp-px-10 hp-d-block hp-transition hp-hover-bg-primary-4 hp-hover-bg-dark-80 hp-border-radius'
                style={{ marginLeft: -10, marginRight: -10 }}
              >
                <Setting2 size='20' />
                <span className='hp-ml-8'>Backoffice</span>
              </Link>
            </Col>
          </Row>
          <Divider />
        </>
      )}
      <Row>
        <Col span={24}>
          <Link
            onClick={() => logout()}
            to='/authentication/login'
            className='hp-p1-body hp-font-weight-500 hp-hover-text-color-primary-2'
          >
            Log out
          </Link>
        </Col>
      </Row>
    </div>
  );

  return (
    <Col>
      <Dropdown overlay={menu} placement='bottomLeft'>
        <div className='hp-border-radius-xl hp-cursor-pointer hp-border-1 hp-border-color-dark-80'>
          <div
            className='hp-border-radius-lg hp-overflow-hidden hp-bg-info-4 hp-m-4 hp-d-flex'
            style={{ minWidth: 32, width: 32, height: 32 }}
          >
            <Avatar size={48} icon={<UserOutlined />} alt='User' />
          </div>
        </div>
      </Dropdown>
    </Col>
  );
}
